// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthenticationForm_content__elh13"};